import { Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';
import { FlatListProps, StyleSheet } from 'react-native';

import { ProductFieldProps } from '../../../constants';

interface ProductsListProps<T> extends Omit<FlatListProps<ProductFieldProps<T>>, 'data'> {
  data: ProductFieldProps<T>[];
  columns: number;
  id: string;
}

export const ProductsList = <T,>({ data, columns, id, ...props }: ProductsListProps<T>) => {
  return (
    <FlatList
      {...props}
      data={data}
      scrollEnabled={false}
      showsVerticalScrollIndicator={false}
      testID={id}
      numColumns={columns}
      keyExtractor={(item, index) => `${item.label}-${index}`}
      ItemSeparatorComponent={() => <Box w="full" h="1px" bgColor={Color['neutral.lightest']} />}
      columnWrapperStyle={columns > 1 ? styles.columnWrapper : undefined}
      maxToRenderPerBatch={10}
      windowSize={5}
      removeClippedSubviews={true}
    />
  );
};

const styles = StyleSheet.create({
  columnWrapper: {
    flex: 1,
    justifyContent: 'space-between',
    gap: Utils.Token.ToInt(Spacing, 'stack.lg'),
  },
});
